export const randomId = () =>
  Math.random()
    .toString(36)
    .replace(/[^a-z]+/g, '');

export const stripIds = (path) =>
  // eslint-disable-next-line no-nested-ternary
  path === '/' ? '/homepage' : path.includes('/blog') ? path : path.replace(/\w+[-]\w+[-]\w+[-]\w+[-]\w+/g, 'ID');
